import { type ReactNode } from 'react';
import { LiquidButton } from '@glinui/ui';
import { cn } from '@/shared/lib/cn';

interface SecondaryButtonProps {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  className?: string;
  type?: 'button' | 'submit';
}

export function SecondaryButton({
  children,
  onClick,
  disabled,
  loading,
  fullWidth = true,
  className,
  type = 'button',
}: SecondaryButtonProps) {
  return (
    <LiquidButton
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      variant="glass"
      intensity="soft"
      className={cn(
        'h-auto py-[13px] px-6',
        'text-[17px] font-semibold text-text-primary',
        'rounded-[16px]',
        'disabled:opacity-50',
        fullWidth && 'w-full',
        className,
      )}
    >
      {loading ? '...' : children}
    </LiquidButton>
  );
}
